import styled from 'styled-components';




export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
`;

export const TitleDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const titleAndListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;



export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
  width: 100%;
`;



export const DocumentsToShareContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
`;

export const DocumentsToShareItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`;

export const DocumentsToShareItemConfirmation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
`;

export const CustomModalContentContainer = styled.div`
  display: flex;
  max-height: 72px;
  overflow-y: auto;
  padding-right: 8px;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.lighterGray};
    border-radius: 3px;
  }
`;



export const AutocompleteContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;

  > div:first-child {
    flex: 1;
    > div:first-child {
      width: 100%;
    }
  }
`;



export const CollapsibleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;



export const GranteesListScrollWrapper = styled.div`
  max-height: 300px;
  position: relative;
  /* Key: Use clip-path instead of overflow to create scroll effect */
  /* This allows content to escape for dropdowns */
`;

export const GranteesListContainerExternal = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
`;

export const GranteesListContainerInternal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 8px 0;
  overflow: visible;
  position: relative;
`;

export const GranteeItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  transition: background-color 0.2s;
  /* Allow dropdown menus to overflow */
  position: relative;
  z-index: 1;

  &:hover {
    background-color: #f5f5f5;
    /* Increase z-index on hover to ensure dropdown appears above other items */
    z-index: 10;
  }
`;

export const GranteeInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const GranteeActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: inherit;

  & .list-actions > button { 
    min-width: 120px;
  }
`;



export const ConfirmModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 32px 24px;
`;

export const ConfirmModalIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmModalText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const ConfirmModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
`;


export const SelectedAgentsListToConfirmationContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
  padding: 24px 0 0 0;
  border-top: 1px solid #F2F2F2;
`;

export const SelectedAgentsListToConfirmationItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

